import { z } from "zod";
import {
  playbookSelectionSchema
} from "./playbook.js";
const signalIdSchema = z.uuid().brand();
function asSignalId(id) {
  return signalIdSchema.parse(id);
}
const metadataFieldIdSchema = z.uuid().brand();
function asMetadataFieldId(id) {
  return metadataFieldIdSchema.parse(id);
}
const signalMetadataSchemaEnumSchema = z.object({
  id: metadataFieldIdSchema,
  key: z.string().min(1).max(100),
  type: z.literal("enum"),
  options: z.array(z.string().min(1)).min(1)
});
const signalMetadataSchemaNumberSchema = z.object({
  id: metadataFieldIdSchema,
  key: z.string().min(1).max(100),
  type: z.literal("number")
});
const signalMetadataSchemaFieldSchema = z.discriminatedUnion("type", [
  signalMetadataSchemaEnumSchema,
  signalMetadataSchemaNumberSchema
]);
const MAX_METADATA_FIELDS = 10;
const signalMetadataSchemaSchema = z.object({
  fields: z.array(signalMetadataSchemaFieldSchema).max(MAX_METADATA_FIELDS)
});
function isValidMetadataField(field) {
  if (field.type === "enum") {
    return field.options.length > 0;
  }
  return true;
}
const signalPayloadSchema = z.object({
  name: z.string().min(1).max(200),
  description: z.string().min(1).max(5e3),
  metadata_schema: signalMetadataSchemaSchema.optional(),
  /**
   * Which playbooks the signal is extracted against. `null` (the column
   * default) means all playbooks and voice agents, including ones created
   * later.
   */
  playbook_scope: playbookSelectionSchema.nullish()
});
function toSignalAdminApp(db) {
  return {
    id: db.id,
    created_at: db.created_at,
    updated_at: db.updated_at,
    name: db.name,
    description: db.description,
    metadata_schema: db.metadata_schema,
    playbook_scope: db.playbook_scope
  };
}
export {
  MAX_METADATA_FIELDS,
  asMetadataFieldId,
  asSignalId,
  isValidMetadataField,
  metadataFieldIdSchema,
  signalIdSchema,
  signalMetadataSchemaFieldSchema,
  signalMetadataSchemaSchema,
  signalPayloadSchema,
  toSignalAdminApp
};
//# sourceMappingURL=signal.js.map
